import Typography from '@mui/material/Typography';

import { BaseDialog } from '../custom-dialog';
import { BaseDialogProps } from '../custom-dialog/types';

export type ConfirmModalProps = Omit<BaseDialogProps, 'action'>;

export default function ConfirmModal({
  content,
  onClose,
  onAccept,
  onCancel,
  ...other
}: Readonly<ConfirmModalProps>) {
  const handleClickAccept = () => {
    onAccept?.();
    onClose();
  };

  const handleClickCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <BaseDialog
      onAccept={handleClickAccept}
      onCancel={handleClickCancel}
      onClose={onClose}
      dialogActionProps={{ sx: { p: 3 } }}
      {...other}
    >
      <Typography variant="body1">{content}</Typography>
    </BaseDialog>
  );
}
